import ReactSelect, { MultiValue, SingleValue } from 'react-select';
import useSelect from '../../hooks/select/useSelect';
import { IFormItemProps } from '../../types/components/form';
import { ISelectOption } from '../../types/components/select';
import { IMultipleSelectLayout, ISelectLayout } from '../../types/layout/select';

export type TSelectProps = (ISelectLayout | IMultipleSelectLayout) & IFormItemProps;

function Select(props: TSelectProps) {
    const {
        additionalClassName, disabled, type, placeholder, onChange, value,
    } = props;

    const { data, loading } = useSelect(props);

    const getValue = () => {
        if (typeof value === 'string' || typeof value === 'number') {
            return data?.filter((el) => el.value === value);
        }
        if (Array.isArray(value) && value.length > 0) {
            return data?.filter((el) => value.includes(el.value));
        }
        return null;
    };

    const onChangeHandler = (v: MultiValue<ISelectOption> | SingleValue<ISelectOption>) => {
        if (Array.isArray(v)) {
            return onChange(v.map((el: ISelectOption) => el.value));
        }
        if (v && typeof v === 'object') {
            const { value: selectedValue } = v as ISelectOption;
            return onChange(selectedValue);
        }
        return onChange(v);
    };

    return (
        <ReactSelect
            isDisabled={disabled}
            isLoading={loading}
            options={data}
            isMulti={type === 'multiple-select'}
            placeholder={placeholder}
            onChange={onChangeHandler}
            isClearable
            value={getValue()}
            className={additionalClassName}
        />
    );
}

export default Select;
